import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../environments/environment";
import {Observable} from 'rxjs';
import {ResDataModal} from './model/resDataModal';
interface JobApplication {
  name: string;
  email: string;
  memo: string;
  resume: File | null;
  sample: File | null;
}
@Injectable({
  providedIn: "root",
})
export class DataService {
  myUrl: string = `${environment.urlApi}`;
  constructor(private http: HttpClient) {}

  public async submitApplication(application: JobApplication): Promise<void> {
    var formData = new FormData();

    // The FormData object provides a way to programmatically submit data that the
    // Browser could have natively submitted using a "<form/>" tag. Each entry here
    // represents a form-control field.
    formData.append("name", application.name);
    formData.append("email", application.email);
    formData.append("memo", application.memo);

    // While the above values are "simple" values, we can add File Blobs to the
    // FormData in the exactly same way.
    // --
    // NOTE: An optional "filename" can be provided for Files. But, for this demo,
    // we're going to allow the native filename to be used for the uploads.
    application.resume && formData.append("resume", application.resume);
    application.sample && formData.append("sample", application.sample);

    var result = await this.http
      .post<void>(
        "./api/upload.cfm",
        formData

        // NOTE: When using a FormData instance to define the request BODY, the
        // correct Content-Type will be automatically provided, along with the
        // necessary "boundary" option that delimits the field values. If you
        // attempt to define the Content-Type explicitly, the "boundary" value
        // will be omitted from the post which will prevent the Lucee Server
        // parsing the request into the Form scope properly.
        // --
        // {
        // 	headers: {
        // 		"Content-Type": "multipart/form-data"
        // 	}
        // }
      )
      .toPromise();
  }

  private jsonData: any;

  setDepot(data: any) {
    this.jsonData = data;
    if (data) {
      localStorage.setItem('depot', JSON.stringify(this.jsonData));
    }else{
      localStorage.removeItem('depot');
    }
    console.log(data);
  }
  // getDepot() {
  //   return localStorage.getItem('depot');
  //   // return this.jsonData;
  // }
  public getStocks() {
    return this.http.get(`${this.myUrl}/api/api/getStock.php`);
  }
  public getStockVendu() {
    return this.http.get(`${this.myUrl}/api/api/getStockVendu.php`);
  }
  public getUsers() {
    return this.http.get(`${this.myUrl}/api/api/getUsers.php`);
  }

  public getClients() {
    return this.http.get(`${this.myUrl}/api/api/getClients.php`);
  }
  public updateClient(Client) {
    return this.http.post(
      `${environment.urlApi}/api/api/updateClient.php`,
      Client
    );
  }
  public addClient(Client) {
    return this.http.post(
      `${environment.urlApi}/api/api/addClient.php`,
      Client
    );
  }
  public deleteClient(Client) {
    return this.http.post(
      `${environment.urlApi}/api/api/deleteClient.php`,
      Client
    );
  }
  //-----------------------------------------------------------------------------------

  public donnee(datatable,data) {
    return this.http.post(`${this.myUrl}/api/api/${datatable}.php`, data);
  }

  public article(data) {
    return this.http.post(`${this.myUrl}/api/api/article.php`, data);
  }
  getData(data): Observable<ResDataModal> {
    return this.http.post<ResDataModal>(`${this.myUrl}/api/api/article.php`, data);
  }
  public fournisseur(data) {
    return this.http.post(`${this.myUrl}/api/api/fournisseur.php`, data);
  }
  public achat(data) {
    return this.http.post(`${this.myUrl}/api/api/achat.php`, data);
  }
  public recapFournisseur(data) {
    return this.http.post(`${this.myUrl}/api/api/paiementFournisseur.php`, data);
  }
  public vente(data) {
    return this.http.post(`${this.myUrl}/api/api/vente.php`, data);
  }  
  public avoirAchat(data) {
    return this.http.post(`${this.myUrl}/api/api/avoirAchat.php`, data);
  }
  public avoir(data) {
    return this.http.post(`${this.myUrl}/api/api/avoir.php`, data);
  }
  public facture(data) {
    return this.http.post(`${this.myUrl}/api/api/facture.php`, data);
  }
  public factureStock(data) {
    return this.http.post(`${this.myUrl}/api/api/factureStock.php`, data);
  }
  public paiementFacture(data) {
    return this.http.post(`${this.myUrl}/api/api/paiementFacture.php`, data);
  }
  public devis(data) {
    return this.http.post(`${this.myUrl}/api/api/devis.php`, data);
  }
  public client(data) {
    return this.http.post(`${this.myUrl}/api/api/client.php`, data);
  }
  public commande(data) {
    return this.http.post(`${this.myUrl}/api/api/commande.php`, data);
  }
  public personnel(data) {
    return this.http.post(`${this.myUrl}/api/api/personnel.php`, data);
  }
  public salaire(data) {
    return this.http.post(`${this.myUrl}/api/api/salaire.php`, data);
  }
  public modePaiement(data) {
    return this.http.post(`${this.myUrl}/api/api/modePaiement.php`, data);
  }
  public type(data) {
    return this.http.post(`${this.myUrl}/api/api/type.php`, data);
  }
  public tva(data) {
    return this.http.post(`${this.myUrl}/api/api/tva.php`, data);
  }
  public liste(data) {
    return this.http.post(`${this.myUrl}/api/api/liste.php`, data);
  }
  public listeDetail(data) {
    return this.http.post(`${this.myUrl}/api/api/listeDetail.php`, data);
  }
  public charge(data) {
    return this.http.post(`${this.myUrl}/api/api/charge.php`, data);
  }
  public paiement(data) {
    return this.http.post(`${this.myUrl}/api/api/paiementAchat.php`, data);
  }
  public paiementAchat(data) {
    return this.http.post(`${this.myUrl}/api/api/paiementAchat.php`, data);
  }
  public paiementVente(data) {
    return this.http.post(`${this.myUrl}/api/api/paiementVente.php`, data);
  }
  public paiementClient(data) {
    return this.http.post(`${this.myUrl}/api/api/paiementClient.php`, data);
  }
  public avoirClient(data) {
    return this.http.post(`${this.myUrl}/api/api/avoir.php`, data);
  }
  public recapClient(data) {
    return this.http.post(`${this.myUrl}/api/api/paiementClient.php`, data);
  }
  public recapClientFacture(data) {
    return this.http.post(`${this.myUrl}/api/api/paiementClientFacture.php`, data);
  }
  public stock(data) {
    return this.http.post(`${this.myUrl}/api/api/stock.php`, data);
  }
  public depot(data) {
    return this.http.post(`${this.myUrl}/api/api/depot.php`, data);
  }
  public stockDepot(data) {
    return this.http.post(`${this.myUrl}/api/api/stockDepot.php`, data);
  }
  public StockInitial(data) {
    return this.http.post(`${this.myUrl}/api/api/StockInitial.php`, data);
  }
  public variationStock(data) {
    return this.http.post(`${this.myUrl}/api/api/variationStock.php`, data);
  }
  public variationStockDepot(data) {
    return this.http.post(`${this.myUrl}/api/api/variationStockDepot.php`, data);
  }
  public rendezVous(data) {
    return this.http.post(`${this.myUrl}/api/api/rendezVous.php`, data);
  }
  public crypt(data) {
    return this.http.post(`${this.myUrl}/api/api/crypt.php`, data);
  }
  public backup() {
    return this.http.get(`${this.myUrl}/api/api/backup.php`);
  }
  public parametre(data) {
		return this.http.post(`${environment.urlApi}/api/api/parametre.php`, data);
	}
  //-----------------------------------------------------------------------------------
  public getAchats() {
    return this.http.get(`${this.myUrl}/api/api/getAchats.php`);
  }
  public updateAchat(Client) {
    return this.http.post(
      `${environment.urlApi}/api/api/updateAchat.php`,
      Client
    );
  }
  public addAchat(Client) {
    // console.log(Client);
    return this.http.post(`${environment.urlApi}/api/api/addAchat.php`, Client);
  }
  public deleteAchat(Client) {
    return this.http.post(
      `${environment.urlApi}/api/api/deleteAchat.php`,
      Client
    );
  }
  public getProduits() {
    return this.http.get(`${this.myUrl}/api/api/getProduits.php`);
  }
  public getArticles() {
    return this.http.get(`${this.myUrl}/api/api/getArticles.php`);
  }
  public getPersonnels() {
    return this.http.get(`${this.myUrl}/api/api/getPersonnels.php`);
  }
  public getPersonnelsActif() {
    return this.http.get(`${this.myUrl}/api/api/getPersonnelsActif.php`);
  }
  public updateArticle(Article) {
    return this.http.post(
      `${environment.urlApi}/api/api/updateArticle.php`,
      Article
    );
  }
  public addArticle(Article) {
    console.log("salut ", Article);
    return this.http.post(
      `${environment.urlApi}/api/api/addArticle.php`,
      Article
    );
  }
  public deleteArticle(Article) {
    return this.http.post(
      `${environment.urlApi}/api/api/deleteArticle.php`,
      Article
    );
  }

  posteFileCrypt(fileToUpload: File) {
    console.log(fileToUpload);
    const endpoint = `${this.myUrl}/api/api/crypt.php`;
    const formData: FormData = new FormData();
    formData.append("image", fileToUpload, fileToUpload.name);
    return this.http.post(endpoint, formData);
  }
  posteFile(id, type, DBase, fileToUpload: File) {
    const endpoint = `${this.myUrl}/api/api/uploadType.php`;
    const formData: FormData = new FormData();
    formData.append("image", fileToUpload, fileToUpload.name);
    formData.append("DBase", DBase);
    formData.append("id", id);
    formData.append("type", type);
    console.log(formData);
    return this.http.post(endpoint, formData);
  }
  posteFileArticle(id,type,DBase,fileToUpload: File) {
    const endpoint = `${this.myUrl}/api/api/uploadArticle.php`;
    const formData: FormData = new FormData();
    formData.append("image", fileToUpload, fileToUpload.name);
    formData.append("DBase", DBase);
    formData.append("id", id);
    formData.append("designation", type);
    // console.log(formData);
    return this.http.post(endpoint, formData);
  }
  public addPersonnel(user) {
    // console.log('salut ', user);
    return this.http.post(
      `${environment.urlApi}/api/api/addPersonnel.php`,
      user
    );
  }
  public deletePersonnel(user) {
    return this.http.post(
      `${environment.urlApi}/api/api/deletePersonnel.php`,
      user
    );
  }
  public getPersonnel() {
    return this.http.get(`${this.myUrl}/api/api/getPersonnels.php`);
  }
  public updatePersonnel(type) {
    return this.http.post(
      `${environment.urlApi}/api/api/updatePersonnel.php`,
      type
    );
  }
  public addType(user) {
    // console.log('salut ', user);
    return this.http.post(`${environment.urlApi}/api/api/addType.php`, user);
  }
  public deleteType(user) {
    return this.http.post(`${environment.urlApi}/api/api/deleteType.php`, user);
  }
  public getTypes() {
    return this.http.get(`${this.myUrl}/api/api/getTypes.php`);
  }
  public updateType(type) {
    return this.http.post(`${environment.urlApi}/api/api/updateType.php`, type);
  }
  public getSousTypes() {
    return this.http.get(`${this.myUrl}/api/api/getSousTypes.php`);
  }
  public updateSousType(sousType) {
    return this.http.post(
      `${environment.urlApi}/api/api/updateSousType.php`,
      sousType
    );
  }
  public addSousType(sousType) {
    return this.http.post(
      `${environment.urlApi}/api/api/addSousType.php`,
      sousType
    );
  }
  public deleteSousType(sousType) {
    return this.http.post(
      `${environment.urlApi}/api/api/deleteSousType.php`,
      sousType
    );
  }
}
